import brandPortalMyShopSettings from "@faire/web-api/routes/brand-portal/my-shop/settings";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var InternationalOrderSettings = function InternationalOrderSettings() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YKn+GK",
    defaultMessage: [{
      "type": 0,
      "value": "Na Faire, pode escolher onde ver os seus produtos. Pode limitar as vendas em certas regiões nas quais já tenha representantes ou distribuidores, ou ainda se os seus produtos não cumprirem as leis de proteção ao consumidor nessas regiões. Também pode ativar as vendas em novas regiões quando tiver tudo pronto para clientes nessas áreas."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "2++wCW",
    defaultMessage: [{
      "type": 0,
      "value": "As alterações a estas definições podem ser feitas a qualquer momento no separador "
    }, {
      "children": [{
        "type": 0,
        "value": "Marketplace"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " no seu portal em "
    }, {
      "children": [{
        "type": 0,
        "value": "Definições da loja"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": ". Aqui, pode selecionar os países para os quais pretende vender, assim como definir os montantes mínimos específicos por localização."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      },
      LinkFormatting: function LinkFormatting(chunks) {
        return shopSettingLinkFormatting(chunks);
      }
    }
  })));
};
var shopSettingLinkFormatting = function shopSettingLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMyShopSettings(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};